import * as types from './UsersTypes';

export default function UsersReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_USERS:
            return {
                ...state,
                getUsers: {
                    ...state.getUsers,
                    users: payload.data,
                    firstUser: payload.first,
                    lastUser: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_USERS_LOADING:
            return {
                ...state,
                getUsers: {
                    ...state.getUsers,
                    loading: true
                },
            };
        case types.GET_USERS_ERROR:
            return {
                ...state,
                getUsers: {
                    ...state.getUsers,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_USERS_BY_ID:
            return {
                ...state,
                getUsersById: {
                    ...state.getUsersById,
                    user: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_USERS_BY_ID_LOADING:
            return {
                ...state,
                getUsersById: {
                    ...state.getUsersById,
                    loading: true,
                },
            };
        case types.GET_USERS_BY_ID_ERROR:
            return {
                ...state,
                getUsersById: {
                    ...state.getUsersById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.UPDATE_USERS_BY_ID:
            return {
                ...state,
                updateUsersById: {
                    ...state.updateUsersById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getUsersById: {
                    ...state.getUsersById,
                    user: {
                        ...state.getUsersById.user,
                        nombre: payload.newFirstName,
                        apellido: payload.newLastName,
                        status: payload.newStatus,
                        role: payload.newRole,
                        pais: payload.newCountry,
                        codigoPais: payload.newCodeCountry
                    },
                },
            };
        case types.UPDATE_USERS_BY_ID_LOADING:
            return {
                ...state,
                updateUsersById: {
                    ...state.updateUsersById,
                    loading: true
                },
            };
        case types.UPDATE_USERS_BY_ID_ERROR:
            return {
                ...state,
                updateUsersById: {
                    ...state.updateUsersById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CREATE_USER:
                return {
                    ...state,
                    createUser: {
                        ...state.createUser,
                        user: {
                            ...state.createUser.user,
                            firstName: payload.userFirstName,
                            lastName: payload.userLastName,
                            email: payload.userEmail,
                            status: payload.userStatus,
                            role: payload.userRole,
                            userIsCreated: payload.userIsCreated
                        },
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        },
                    },
                };
        case types.CREATE_USER_LOADING:
            return {
                ...state,
                createUser: {
                    ...state.createUser,
                    loading: true
                },
            };
        case types.CREATE_USER_ERROR:
            return {
                ...state,
                createUser: {
                    ...state.createUser,
                    user: {
                        ...state.createUser.user,
                        firstName: null,
                        lastName: null,
                        email: null,
                        status: null,
                        role: null,
                        userIsCreated: null
                    },
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.UPDATE_USER_PASSWORD:
            return {
                ...state,
                updateUserPassword: {
                    ...state.updateUserPassword,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_USER_PASSWORD_LOADING:
            return {
                ...state,
                updateUserPassword: {
                    ...state.updateUserPassword,
                    loading: true
                },
            };
        case types.UPDATE_USER_PASSWORD_ERROR:
            return {
                ...state,
                updateUserPassword: {
                    ...state.updateUserPassword,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_USER_AVATAR:
            return {
                ...state,
                updateUserAvatar: {
                    ...state.updateUserAvatar,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_USER_AVATAR_LOADING:
            return {
                ...state,
                updateUserAvatar: {
                    ...state.updateUserAvatar,
                    loading: true
                },
            };
        case types.UPDATE_USER_AVATAR_ERROR:
            return {
                ...state,
                updateUserAvatar: {
                    ...state.updateUserAvatar,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.USERS_RESET_STATE:
            return {
                ...state,
                getUsers: {
                    users: [],
                    firstUser: null,
                    lastUser: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getUsersById: {
                    user: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                createUser: {
                    user: {
                        firstName: null,
                        lastName: null,
                        email: null,
                        status: null,
                        role: null,
                        userIsCreated: null,
                    },
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                updateUsersById: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updateUserPassword: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updateUserAvatar: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            }
    
        default:
            return state;
    }
}